import { render, staticRenderFns } from "./Jewellery.vue?vue&type=template&id=2c5b11dc"
import script from "./Jewellery.vue?vue&type=script&lang=js"
export * from "./Jewellery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports